{
  "info": "Tiedot",
  "negative": "Virhe",
  "positive": "Onnistui"
}
